module.exports = __webpack_public_path__ + "img/red-bag.750a674c.gif";